import { getFirebaseAuth } from '@/lib/firebase'
import { signInWithCustomToken, signOut } from 'firebase/auth'

/** Bridge backend JWT session to Firebase when the SDK has no active user or user changed. */
export async function bridgeFirebaseAuth(
    firebaseToken?: string | null,
    expectedUserId?: string | null,
): Promise<void> {
    if (!firebaseToken?.trim()) return

    try {
        const fbAuth = getFirebaseAuth()
        const current = fbAuth.currentUser
        if (current) {
            if (expectedUserId && current.uid === expectedUserId) {
                return
            }
            await signOut(fbAuth)
        }
        await signInWithCustomToken(fbAuth, firebaseToken)
    } catch (error) {
        console.error('Firebase bridged login failed:', error)
    }
}

/** Sign out of Firebase Auth (Firestore/messaging) when the app session ends. */
export async function signOutFirebaseAuth(): Promise<void> {
    try {
        const fbAuth = getFirebaseAuth()
        if (fbAuth.currentUser) {
            await signOut(fbAuth)
        }
    } catch (error) {
        console.error('Firebase signOut failed:', error)
    }
}
